import Fundatio from "../../../layouts/apps/Fundatio";
import LinkedText from "../../../components/LinkedText";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";

export default function FundatioPrivacyPolicy() {
    const rightContent = (
        <div>
            <p>Fundatio is a folder structure management app for macOS, developed and maintained by a solo developer
                (me, Çağrı
                Gökpunar). This Privacy Policy explains how the app handles your data and your privacy rights.</p>

            <h3>1. No Data Collection</h3>
            <p>Fundatio does not collect, transmit, or upload any personal or project data. All your templates and
                folder structures
                stay entirely on your device.</p>

            <h3>2. Local Data Storage</h3>
            <p>Your data (such as folder templates, YAML configurations, project variables, and AI assistant settings)
                is stored locally on your devices. The app does not connect to external
                servers or cloud services, except for optional AI features when you provide your own API keys.</p>

            <h3>3. AI Integration</h3>
            <p>When using AI features, Fundatio connects directly to your chosen AI service (Mistral, OpenAI, Anthropic,
                or DeepSeek) using your own API key.
                Your prompts and generated templates are sent to these services according to their respective privacy
                policies. No data is stored on Fundatio's servers. Actually, Fundatio does not have any servers.
            </p>

            <h3>4. No Third Parties</h3>
            <p>Fundatio does not use third-party analytics, ads, crash reporting tools, or any embedded trackers.</p>

            <h3>5. Permissions</h3>
            <p>The app requests permission to create folder structures at your chosen locations.
                This is a system-required permission to ensure your templates and settings are saved persistently.</p>

            <h3>6. Your Control</h3>
            <p>You have full control over your data. You can manually back up or delete your templates. The app includes
                export features for templates as YAML files, but nothing will be shared
                without your explicit action.</p>

            <h3>7. Security Notice</h3>
            <p>While Fundatio securely stores your data locally, it does not encrypt it. I recommend using macOS's
                built-in security features like FileVault or Time Machine for added protection.</p>

            <h3>8. Changes to This Policy</h3>
            <p>If I ever update this privacy policy, the changes will be reflected in the app or announced in the
                release notes.</p>

            <h3>9. Contact Me</h3>
            <p>If you have any questions about privacy, reach out to me: </p>
            <LinkedText text={"cagri@mpospirit.com"} href={"mailto:cagri@mpospirit.com"} icon={faEnvelope}></LinkedText>
        </div>
    )
    return (
        <div className="cogio-privacy-policy-page">
            <Fundatio rightContent={rightContent}/>
        </div>
    )
}